"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IS_LEGACY_CONTEXT = exports.THEME_CLASSNAMES = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var THEME_CLASSNAMES = {
  "default": 'default-theme'
};
exports.THEME_CLASSNAMES = THEME_CLASSNAMES;
var IS_LEGACY_CONTEXT = typeof _react["default"].createContext !== 'function';
exports.IS_LEGACY_CONTEXT = IS_LEGACY_CONTEXT;